import { apiSlice } from "./apiSlice";
import config from "../../config.json";

export const partnerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadPartnerAllCandidate: builder.query({
      query: ({ partId, perfId }) =>
        (config.GetPartnerUsers || "") + partId + "&perfId=" + perfId,
      providesTags: ["PartnerCandidates"],
    }),
    loadPartnerUsers: builder.query({
      query: (id) => (config.GetPartnerPerformers || "") + id,
      providesTags: ["PartnerUsers"],
    }),
    loadPartCandidatePoOrders: builder.query({
      query: ({ id, type, currentPerformerId }) =>
        (config.GetPurchaseOrders || "") +
        id +
        "&type=" +
        type +
        (currentPerformerId ? `&currentPerformerId=${currentPerformerId}` : ""),
      providesTags: ["PurchaseOrders"],
    }),
    loadPartnerAllCandidateRpt: builder.query({
      query: ({ year, month, partId, type, candId }) =>
        `${config.GetBulkReportCandidates}${year}&month=${month}&partnerId=${partId}&type=${type}&candId=${candId}`,
      providesTags: ["PartnerCandidatesReport"],
    }),
    partnerCandidateGenerateBulkInv: builder.mutation({
      query: (data) => ({
        url: config.GenerateBulkInvoice,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PartnerCandidatesReport"],
    }),
    loadPartnerFilterCandidate: builder.query({
      query: ({ partId, perfId }) =>
        `${config.GetPartnerUsers}${partId}&perfId=${perfId}`,
      providesTags: ["PartnerCandidates"],
    }),
    loadPartnerCandidateApps: builder.query({
      query: (id) => `${config.GetPerformerApplication}${id}`,
      providesTags: ["CandidateApps"],
    }),
    loadCandidateAppRuningTasks: builder.query({
      query: ({ wfId, userId }) =>
        `${config.GetRunningTask}${wfId}&performerId=${userId}`,
      providesTags: ["WorkflowTasks"],
    }),
    partnerCandidateDocSend: builder.mutation({
      query: (data) => ({
        url: config.UpdateDocSentStatus || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Documents"],
    }),
    partnerCandidateDocDelete: builder.mutation({
      query: ({ id, type }) => ({
        url: `${config.DeleteDocumentByApplicant}${id}&type=${type}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Documents", "WorkflowTasks"],
    }),
    loadPartRoleTypes: builder.query({
      query: (name) => `${config.GetCodemanager || ""}${name}`,
    }),
    addPartnerUser: builder.mutation({
      query: (data) => ({
        url: config.AddPartnerPerformer || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PartnerUsers"],
    }),
    updatePartPoOrderSign: builder.mutation({
      query: (data) => ({
        url: config.UpdatePoOrderSign || "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["PurchaseOrders"],
    }),
    printGeneratedPoOrders: builder.mutation({
      query: (data) => ({
        url: config.PrintTemplate || "",
        method: "POST",
        body: data,
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useLoadPartnerAllCandidateQuery,
  useLazyLoadPartnerAllCandidateQuery,
  useLoadPartnerUsersQuery,
  useLazyLoadPartnerUsersQuery,
  useLoadPartCandidatePoOrdersQuery,
  useLazyLoadPartCandidatePoOrdersQuery,
  useLoadPartnerAllCandidateRptQuery,
  useLazyLoadPartnerAllCandidateRptQuery,
  usePartnerCandidateGenerateBulkInvMutation,
  useLoadPartnerFilterCandidateQuery,
  useLazyLoadPartnerFilterCandidateQuery,
  useLoadPartnerCandidateAppsQuery,
  useLazyLoadPartnerCandidateAppsQuery,
  useLoadCandidateAppRuningTasksQuery,
  useLazyLoadCandidateAppRuningTasksQuery,
  usePartnerCandidateDocSendMutation,
  usePartnerCandidateDocDeleteMutation,
  useLoadPartRoleTypesQuery,
  useLazyLoadPartRoleTypesQuery,
  useAddPartnerUserMutation,
  useUpdatePartPoOrderSignMutation,
  usePrintGeneratedPoOrdersMutation,
} = partnerApiSlice;
